import styled from "styled-components";

export const AccordionItemWrapper = styled.section`
  padding: 16px 0;

  & .accordionContent {
    line-height: 1.5em;
    max-height: 0;
    overflow: hidden;
    transition: none; /* Disable the transition */

    h4 {
      font-weight: normal
    }

    li:not(:last-child) {
      margin-bottom: 16px
    }
  }

  .accordionHeader {
    padding: 0 8px
  }

  &.active .accordionHeader {
    margin-bottom: 16px;
  }

  &.active .accordionContent {
    max-height: 10000px;
    animation: slideDown 0.5s ease-in-out forwards;
  }

  @keyframes slideDown {
    from {
      max-height: 0;
    }
    to {
      max-height: 10000px /* Adjust this value to match the .element.active max-height */
    }
  }
`;